import { CanDeactivateFn } from '@angular/router';

/** 未保存変更を持ちうるコンポーネントが実装するインターフェース */
export interface UnsavedChangesAware {
  /** 未保存の変更があるか */
  hasUnsavedChanges(): boolean;
  /** 離脱確認ダイアログを開き、ユーザーの選択を待つ（true = 離脱許可） */
  confirmLeave(): Promise<boolean>;
}

/**
 * 未保存変更ガード。未保存の変更がある状態でルートを離れようとしたとき、
 * コンポーネント側の確認ダイアログでユーザーに離脱可否を問い合わせる。
 * ウィザードは `?step=N` をクエリで同期するため、クエリのみが変わる
 * 同一パス内の遷移（ブラウザの戻る/進む含む）は常に許可する。
 */
export const unsavedChangesGuard: CanDeactivateFn<UnsavedChangesAware> = (
  component,
  _route,
  currentState,
  nextState,
) => {
  // クエリを除いたパスが同じなら（?step=N の同期など）確認不要
  const stripQuery = (url: string) => url.split('?')[0];
  if (stripQuery(currentState.url) === stripQuery(nextState.url)) {
    return true;
  }
  if (!component.hasUnsavedChanges()) {
    return true;
  }
  return component.confirmLeave();
};
